var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2128 2.53052C15.559 2.53052 16.8501 3.0573 17.802 3.99498C18.754 4.93267 19.2887 6.20444 19.2887 7.53052V8.53052H9.13678V7.53052C9.13678 6.20444 9.67157 4.93267 10.6235 3.99498C11.5754 3.0573 12.8665 2.53052 14.2128 2.53052ZM21.3191 8.53052V7.53052C21.3191 5.674 20.5704 3.89352 19.2377 2.58077C17.905 1.26802 16.0975 0.530518 14.2128 0.530518C12.328 0.530518 10.5205 1.26802 9.18779 2.58077C7.85509 3.89352 7.10638 5.674 7.10638 7.53052V8.53052H0V28.5305C0 29.5914 0.427832 30.6088 1.18938 31.3589C1.95092 32.1091 2.9838 32.5305 4.06079 32.5305H24.3647C25.4417 32.5305 26.4746 32.1091 27.2361 31.3589C27.9977 30.6088 28.4255 29.5914 28.4255 28.5305V8.53052H21.3191Z",
    fill: "var(--klothed-textColor)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.c6fb333310f43bb5608f54d4e1b2ebe4.svg";
export { ForwardRef as ReactComponent };